<template>
    <section class="step-1">
        <p v-if="!valid" class="no-dates">Les réservations sont temporairement indisponibles, pour tout besoin d'information veuillez contacter l'équipe Grands Espaces</p>
        <div class="wrap" v-if="valid">
            <form @submit.prevent="nextStep()">
                <div class="une-ligne">
                    <label for="dates">
                        <i class="icon-chevron-r"></i>
                        Date de votre {{tripLabel()}}
                    </label>
                    <custom-select
                            id="dates"
                            class="calendrier"
                            v-model="form.tripDates"
                            :options="datesOptions">
                    </custom-select>
                </div>
                <div class="une-ligne">
                    <label>
                        <i class="icon-chevron-r"></i>
                        Nombre de {{roomLabel()}}
                    </label>
                    <div class="rb-cabines">
                        <template v-for="i in 5" v-if="form.cabinCount < 6">
                            <input type="radio"
                                   name="cabin-count"
                                   :id="`cabin-count-${i}`"
                                   :value="i"
                                   required
                                   v-model="form.cabinCount">
                            <label :for="`cabin-count-${i}`">{{ i }}</label>
                        </template>

                        <a href="#" @click.prevent="openModal" class="plus">
                            ou +
                        </a>
                    </div>
                </div>
                <div class="une-ligne cta">
                    <button type="submit"
                            class="btn chevron"
                            :disabled="!valid">
                        Valider
                    </button>
                </div>
                <p class="help"><a :href="contactFormUrl">Vous avez besoin d'être accompagné dans votre démarche de réservation ?</a></p>
            </form>
        </div>
    </section>
</template>

<script>
    import {DateTime} from 'luxon';
    import Modal from '../../libs/Modal'

    export default {
        props: {
            dates: {
                type: Array,
                required: true,
            },
            contactFormUrl: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                form: {
                    tripDates: this.dates[0],
                    cabinCount: 1,
                },
            };
        },
        computed: {
            datesOptions() {
                return this.dates.map(date => {
                    date.label = this.formatDateInterval(date.start, date.end);
                    return date;
                });
            },
            valid() {
                return this.form.tripDates
                    && this.form.tripDates.start
                    && this.form.tripDates.end
                    && this.form.cabinCount > 0;
            },
        },
        methods: {
            /**
             * @param {DateTime} start
             * @param {DateTime} end
             */
            formatDateInterval(start, end) {
                let startString = start.hasSame(end, 'year') ?
                    start.toLocaleString({month: 'long', day: 'numeric'}) :
                    start.toLocaleString(DateTime.DATE_FULL);
                let endString = end.toLocaleString(DateTime.DATE_FULL);

                return `${startString} au ${endString}`;
            },
            nextStep() {
                if (this.valid) {
                    this.$emit('complete', this.form);
                }
            },
            tripLabel(){
                return this.$parent.cruise.is_circuit ? 'circuit' : 'croisière'
            },
            roomLabel(){
                return this.$parent.cruise.is_circuit ? 'chambres' : 'cabines'
            },
            openModal(){
                Modal.showModal("#modal-call-to");
            }
        },
        mounted(){

        }
    }
</script>


// WEBPACK FOOTER //
// assets/js/components/cruise-configurator/TripBooking.vue